<template>
    <div>
        <div class="panel panel-default">
            <div class="panel-heading">Filters</div>

            <div class="panel-body">
                <div class="row">
                    <div class="col-md-6">
                        <label for="select-study">Study</label>

                        <multiselect
                            v-model="selectedStudy"
                            :options="studiesList"
                            :multiple="true"
                            track-by="value"
                            label="label"
                            :close-on-select="false"
                        >
                            <template slot="singleLabel" slot-scope="{ option }">
                                {{ option.label }}
                            </template>
                        </multiselect>
                    </div>

                    <div class="col-md-6">
                        <label for="select-study-year">Study year</label>

                        <multiselect
                            v-model="selectedStudyYear"
                            :options="studyYearsList"
                            :multiple="true"
                            :close-on-select="false"
                        ></multiselect>
                    </div>
                </div>
            </div>
        </div>

        <div class="row dnd-wrapper">
            <div
              v-if="permissions.admin || !activity.edition.schedule_final"
              :class="`col-md-${cols} dnd-target`"
            >
                <subscriptions-list
                    :activity="activity"
                    :isDraggable="companyPreference"
                    heading="Rejected"
                    list="rejected"
                >
                </subscriptions-list>
            </div>

            <div
              v-if="!activity.edition.schedule_final"
              :class="`col-md-${cols} dnd-target`"
            >
                <subscriptions-list
                    :activity="activity"
                    :isDraggable="companyPreference"
                    heading="Pending assignment"
                    list="pending"
                >
                </subscriptions-list>
            </div>

            <div :class="`col-md-${cols} dnd-target`">
                <subscriptions-list
                    :activity="activity"
                    :isDraggable="canDrag"
                    heading="Reserve list"
                    list="reserve"
                >
                </subscriptions-list>
            </div>

            <div :class="`col-md-${cols} dnd-target`">
                <subscriptions-list
                    :activity="activity"
                    :isDraggable="canDrag"
                    heading="Selected"
                    list="selected"
                >
                </subscriptions-list>
            </div>

            <div
              v-if="admin"
              :class="`col-md-${cols} dnd-target`"
            >
                <subscriptions-list
                    :activity="activity"
                    heading="Student unsubscribed"
                    list="unsubscribed"
                >
                </subscriptions-list>
            </div>
        </div>

    </div>
</template>

<script>
import Multiselect from 'vue-multiselect';
import draggable from 'vuedraggable';

export default {
  components: {
    Multiselect,
    draggable,
  },

  props: [
    'activity',
    'is-timeslots',
    'canSortSubscriptions',
    'store-permission',
    'company-preference',
    'max-subscriptions',
    'subscriptions',
    'pending',
    'reserves',
    'rejected',
    'unsubscribed',
    'admin',
    'studies',
    'study-years',
  ],

  computed: {
    canDrag() {
      return this.companyPreference
        && (!this.activity.edition.schedule_final || this.permissions.admin)
    },
    cols() {
      return this.admin ? 3 : 4
    },
    permissions() {
      return this.$store.state.permissions;
    },
    selectedStudy: {
      get () { return this.$store.state.selectedStudy; },
      set (value) { this.$store.commit('updateSelectedStudy', value) }
    },
    selectedStudyYear: {
      get () { return this.$store.state.selectedStudyYear; },
      set (value) { this.$store.commit('updateSelectedStudyYear', value) }
    },
    studiesList() {
        return this.$store.state.studies;
    },
    studyYearsList() {
        return this.$store.state.studyYears;
    },
  },

  created: function() {
    $('document').ready(function() {
      $('.select2').select2();
    });

    this.$store.commit('prepareStudies', {
      studies: this.studies,
      studyYears: this.studyYears
    });

    this.$store.commit('loadActivityId', this.activity.id);

    this.$store.commit('loadSubscriptions', {
      pending: this.pending,
      reserve: this.reserves,
      selected: this.subscriptions,
      rejected: this.rejected,
      unsubscribed: this.unsubscribed,
    });

    this.$store.commit('loadPermissions', {
      sortSubscriptions: this.canSortSubscriptions,
      admin: this.admin,
    });

    this.$store.commit('loadMaxSubscriptions', this.maxSubscriptions);
  },
}
</script>

<style lang="scss" scoped>
.dnd-wrapper {
  display: flex;
  flex-direction: row;

  .dnd-target {
    flex-direction: column;
    display: flex;

    .panel {
      flex: 1;
    }
  }
}
</style>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
